import {
  createComponentPreviewMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import { texts } from './constants.preview';
import type { FreemiumBannerOdeditorMapperProps } from '../FreemiumBannerOdeditor.types';

export const props = withCompInfo<FreemiumBannerOdeditorMapperProps, any>()(
  ['direction', 'metaSiteId', 'translate'],
  ({ direction, metaSiteId, translate }) => {
    const href = `https://manage.wix.com/premium-purchase-plan/dynamo?siteGuid=${metaSiteId}&referralAdditionalInfo=editor3_PREVIEW_FREE_SITE_BANNER_UPGRADE_NOW`;

    return {
      direction,
      textBeforeLogo:
        translate(texts.NAMESPACE, texts.MAIN_TEXT_KEY) ||
        texts.MAIN_TEXT_DEFAULT,
      buttonText:
        translate(texts.NAMESPACE, texts.BUTTON_TEXT_KEY) ||
        texts.BUTTON_TEXT_DEFAULT,
      href,
    };
  },
);

export default createComponentPreviewMapperModel({ props });
